import { ComponentProps, useEffect } from 'react'
import { withRouter } from 'next/router'
import styled from 'styled-components'
import { object } from 'prop-types'
import { useLabelsFromAPI } from '@dmi-mch/hooks'
import { getSiteLanguage } from '@utils/storage'
import IntersectionCapture from '@reusable-modules/IntersectionCapture'
import Filters from './components/Filters'
import EventsList from './components/EventsList'
import { useModuleContext } from './contexts/EventsContext'
import useEventsAndFiltersData from './hooks/useEventsAndFiltersData'
import { Container, Spinner } from '@mch-group/uikit-components'

const EventsMain = ({ router }) => {
  // @ts-ignore
  const [{ paginationInfo, isLoadingNewpage }, dispatch] = useModuleContext()
  const { labels: systemLabels } = useLabelsFromAPI(['Events'], getSiteLanguage())
  // Needs this until we upgrade NextJS version
  useEffect(() => {
    dispatch({ type: 'SET_ROUTER', payload: router })
  }, [dispatch, router])

  // Sets all the labels from Labels System.
  useEffect(() => {
    if (systemLabels) {
      dispatch({ type: 'SET_LABELS', payload: systemLabels })
    }
  }, [dispatch, systemLabels])

  const { loadNextPage } = useEventsAndFiltersData()

  return (
    <EventConainer className='px-5 px-lg-8 px-md-7 mt-0'>
      <Filters />
      <EventsList />
      {paginationInfo && paginationInfo.hasMore && (
        //@ts-ignore
        <IntersectionCapture onIntersect={loadNextPage} active={!isLoadingNewpage} params={{ rootMargin: '500px' }} />
      )}
      {isLoadingNewpage && <LoaderStyled theme='light' variant='page' />}
    </EventConainer>
  )
}

const LoaderStyled = styled(Spinner)<ComponentProps<typeof Spinner>>`
  margin: 0 auto 40px auto !important;
  display: block !important;
`
const EventConainer = styled(Container)`
  @media (max-width: 767px) {
    position: relative;
    top: -3em;
  }
`

EventsMain.propTypes = {
  router: object
}

export default withRouter(EventsMain)
